export enum RoutesOffersEnum {
  PLANS = 'oferta-plans' as any,
  BENEFITS_COMISSIONS = 'oferta-beneficios-comissiones' as any,
  CREDITCARD = 'oferta-tarjeta-credito' as any,
  CLOSINGDATE = 'oferta-fecha-cierre' as any
}
